import { createTheme } from "@mui/material/styles"

export const theme = createTheme({
  components: {
    MuiTextField: {
      defaultProps: {
        variant: "standard",
      },
    },
    MuiSelect: {
      defaultProps: {
        variant: "standard",
      },
    },
    MuiDialog: {
      defaultProps: {
        disableEscapeKeyDown: false,
      },
    },
  },
})
